import React from 'react';
import { withRouter } from 'react-router-dom';

class Processed2 extends React.Component {

    constructor(props) {
        super(props);

        const { match: { params } } = this.props;
        this.userName = params.userName.replace(/_/g, ' ');;
        this.magiclink = `https://fivestone-cte.s3.us-east-2.amazonaws.com/Export/${params.uuid}.mp4`;

        this.homepage = this.homepage.bind(this);
    }

    homepage() {

        this.props.history.push('/');
    }

    render() {
        return (
            <div>
                <img src="img/texture1.png" className="backgroundfill" alt=""/>
                    
                <div className="side-menu w40">
                    <div className="cover w40"></div>
                    <img src="/img/7c9e5d0f857314f5e2aaf4d2bd27426a.png" className="cover-thumbb" alt=""/>
                </div>

                <div className="body-con w60">
                    <img src="/img/top.png" alt="exsample gif" srcSet="" className="hero-image"/>
                    <div className="center-gold deskhidden"></div>            
                    <div className="textcon processed2">
                    </div>
                   
                    <h3 className="main-color processed2">watch <span id="nameOfPerson" > {this.userName}'s </span>video:</h3>

                    <div className="video-con pro2">
                        <video className="hero-video" controls  preload="auto">
                            <source src={this.magiclink} type='video/mp4'/>
                        </video>
                    </div>
                  
                    <h1 className="main-color processed2">now, what are you thankful for?</h1>

                    <div className="next-button-con" onClick={this.homepage} 
                        data-amplify-analytics-on='click'
                        data-amplify-analytics-name='click'
                        data-amplify-analytics-attrs='attr:CreateVideo'>
                        <div className="next-button">
                            <div className="nexr-button-innercon">
                                <div className="next-button-text">Create your music video</div>
                                <div className="next-button-arrow"><img src="/img/movie.svg" alt=""/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Processed2);